import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
import { useAuthStore} from "@/stores/authStore";
import { useUserSettingsStore } from "@/stores/userSettingsStore";
import UserMetrics from "@/components/UserMetrics.vue";

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

const authStore = useAuthStore();
const settingsStore = useUserSettingsStore();

try {
    await authStore.fetchCurrentUser();
    if (authStore.isAuthenticated) {
        await settingsStore.fetchSettings();
    }
} catch (error) {
    console.error('Failed to initialize app:', error);
}
app.component('UserMetrics', UserMetrics);
app.mount('#app')
